__webpack_require__.p = "/reports-dialogs-routing/referrals-hub/";